// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface AwsEksLogging
 */
export interface AwsEksLogging {
  /**
   *
   * @type {boolean}
   * @memberof AwsEksLogging
   */
  api?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AwsEksLogging
   */
  audit?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AwsEksLogging
   */
  authenticator?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AwsEksLogging
   */
  controllerManager?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AwsEksLogging
   */
  scheduler?: boolean;
}

/**
 * Check if a given object implements the AwsEksLogging interface.
 */
export function instanceOfAwsEksLogging(value: object): value is AwsEksLogging {
  return true;
}

export function AwsEksLoggingFromJSON(json: any): AwsEksLogging {
  return AwsEksLoggingFromJSONTyped(json, false);
}

export function AwsEksLoggingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AwsEksLogging {
  if (json == null) {
    return json;
  }
  return {
    api: json['api'] == null ? undefined : json['api'],
    audit: json['audit'] == null ? undefined : json['audit'],
    authenticator:
      json['authenticator'] == null ? undefined : json['authenticator'],
    controllerManager:
      json['controller_manager'] == null
        ? undefined
        : json['controller_manager'],
    scheduler: json['scheduler'] == null ? undefined : json['scheduler'],
  };
}

export function AwsEksLoggingToJSON(json: any): AwsEksLogging {
  return AwsEksLoggingToJSONTyped(json, false);
}

export function AwsEksLoggingToJSONTyped(
  value?: AwsEksLogging | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    api: value['api'],
    audit: value['audit'],
    authenticator: value['authenticator'],
    controller_manager: value['controllerManager'],
    scheduler: value['scheduler'],
  };
}
